import  { CSSProperties } from "styled-components"
import React from "react"

interface CheckboxInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string,
    message?: string,
    error?: boolean
    containerStyles?: CSSProperties
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({
    label,
    value,
    message,
    required,
    error,
    containerStyles,
    className,
    ...inputProps }) => {
    return (
        <div className={`input-container ${error ? 'error' : ''} ${className ?? ''}`} style={containerStyles}>
            <div className="toggle-wrapper">
                <span className="input-label">{label}{required && "*"}</span>
                <label className="toggle-switch">
                    <input type="checkbox" value={value} required={required} {...inputProps} />
                    <span className="toggle-slider" />
                </label>
            </div>
            {message && <span className="input-message">{message}</span>}
        </div>
    )
}

export default CheckboxInput